// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx component.
export const MEETINGS_TABS = ["recent", "upcoming", "notes", "action-items"] as const;
export type MeetingsTabType = (typeof MEETINGS_TABS)[number];
